import React from "react";
import { Search, BarChart3, Users, Briefcase, Settings, FileText, ShieldCheck, Bell, ArrowRight } from "lucide-react";

const BARS = ["#008080", "#008080", "#008080", "#008080", "#008080", "#D99516", "#D99516", "#D99516", "#D99516", "#D99516", "#D99516", "#DC5050", "#DC5050", "#DC5050", "#DC5050"];
const HEIGHTS = [88, 80, 92, 74, 84, 66, 72, 60, 78, 68, 62, 70, 58, 76, 64];
const FINDINGS = [
  { name: "Data Principal Accountability", sev: "High", dot: "#DC5050", chip: "#B42318" },
  { name: "Consent Management", sev: "Medium", dot: "#008080", chip: "#925C00" },
  { name: "Data Protection Impact Assessment", sev: "High", dot: "#D99516", chip: "#B42318" },
];
const ACTIVITY = [
  { icon: FileText, label: "Evidence uploaded", ts: "2m ago" },
  { icon: ShieldCheck, label: "Control status changed", ts: "15m ago" },
  { icon: Bell, label: "New finding assigned", ts: "32m ago" },
];
const RAIL = [Search, BarChart3, Users, Briefcase, Settings];
const CIRC = 2 * Math.PI * 26;

const Panel = ({ id, title, right, children, footer }) => (
  <div className="login-preview-panel" data-testid={`login-preview-${id}`}>
    <div className="login-preview-panel-header"><strong>{title}</strong>{right && <span>{right}</span>}</div>
    <div className="login-preview-panel-content">{children}</div>
    {footer && <div className="login-preview-panel-footer">{footer}<ArrowRight size={9} /></div>}
  </div>
);

// Illustrative product preview, not authenticated assessment data or interactive controls.
export const DashboardPreview = () => (
  <div aria-hidden="true" className="login-dashboard-preview" data-testid="login-dashboard-preview">
    <div className="login-preview-chrome"><span /><span /><span /></div>
    <div className="login-preview-body">
      <div className="login-preview-rail"><strong>CX</strong>{RAIL.map((Icon, i) => <Icon key={i} size={13} className={i === 0 ? "active" : ""} />)}</div>
      <div className="login-preview-main">
        <div className="login-preview-header" data-testid="login-preview-header">
          <strong>Overview</strong>
          <div className="login-preview-search"><Search size={9} /><span>Search controls, findings...</span></div>
        </div>
        <div className="login-preview-panels">
          <Panel id="score" title="Compliance Score">
            <div className="login-preview-score" data-testid="login-preview-score-value">
              <svg viewBox="0 0 64 64">
                <circle cx="32" cy="32" r="26" fill="none" stroke="#e3edf2" strokeWidth="7" />
                <circle cx="32" cy="32" r="26" fill="none" stroke="var(--login-accent)" strokeWidth="7" strokeLinecap="round" strokeDasharray={CIRC} strokeDashoffset={CIRC * 0.22} transform="rotate(-90 32 32)" />
                <text x="32" y="32" textAnchor="middle" fill="var(--login-primary)" fontSize="13" fontWeight="700">78%</text>
                <text x="32" y="42" textAnchor="middle" fill="var(--login-accent)" fontSize="7" fontWeight="500">Good</text>
              </svg>
              <span>↑ 12% vs last month</span>
            </div>
          </Panel>
          <Panel id="pillars" title="Pillars Status" right="15 Pillars">
            <div className="login-preview-bars" data-testid="login-preview-pillar-bars">
              {BARS.map((color, i) => <span key={i} style={{ height: `${HEIGHTS[i]}%`, background: color }} />)}
            </div>
            <div className="login-preview-legend" data-testid="login-preview-pillar-legend">
              {[["#008080", "5 Green"], ["#D99516", "6 Amber"], ["#DC5050", "4 Red"]].map(([color, label]) => (
                <span key={label}><span className="login-preview-dot" style={{ background: color }} />{label}</span>
              ))}
            </div>
          </Panel>
          <Panel id="findings" title="Top Open Findings" footer="View all findings">
            <ul className="login-preview-list">
              {FINDINGS.map((finding, i) => (
                <li key={finding.name} data-testid={`login-preview-finding-${i}`}>
                  <span className="login-preview-dot" style={{ background: finding.dot }} />
                  <span className="login-preview-item-name">{finding.name}</span>
                  <span className="login-preview-severity" style={{ background: `${finding.chip}12`, color: finding.chip }}>{finding.sev}</span>
                </li>
              ))}
            </ul>
          </Panel>
          <Panel id="activity" title="Recent Activity" footer="View all activity">
            <ul className="login-preview-list">
              {ACTIVITY.map(({ icon: Icon, label, ts }, i) => (
                <li key={label} data-testid={`login-preview-activity-${i}`}>
                  <span className="login-preview-activity-icon"><Icon size={9} /></span>
                  <span className="login-preview-item-name">{label}</span>
                  <span className="login-preview-time">{ts}</span>
                </li>
              ))}
            </ul>
          </Panel>
        </div>
      </div>
    </div>
  </div>
);